import { render, staticRenderFns } from "./ColorSelectorExt.vue?vue&type=template&id=852d7932&scoped=true&"
import script from "./ColorSelectorExt.vue?vue&type=script&lang=js&"
export * from "./ColorSelectorExt.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelectorExt.vue?vue&type=style&index=0&id=852d7932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852d7932",
  null
  
)

export default component.exports